<template>
  <div>
    <div class="text-xs-right">
      <v-btn color="primary" outline @click="showModelCreateCouponPool = true">
        <em class="fas fa-plus" />
        &nbsp; เพิ่มคูปอง&nbsp;
      </v-btn>
    </div>
    <v-layout column>
      <v-pagination
        v-model="page"
        :total-visible="6"
        :length="pagelength"
        class="mb-3"
        @input="setup()"
      ></v-pagination>
      <div v-if="loading" class="text-xs-center mt-5">
        <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
      </div>
      <div
        v-for="(item, index) in ecouponPoolData"
        v-else
        :key="`ecoupon-pool-setting-key-${index + 1}`"
        style="border: 2px solid #ff846d; border-radius: 16px; position: relative; width: 100%"
        class="pa-3 elevation-3 mb-3 pt-0"
      >
        <div class="text-xs-right">
          <v-btn icon @click="showEditEcoupon(item)"><v-icon color="#ff846d">edit</v-icon></v-btn>
          <v-btn icon @click="deleteEcoupon(item.id)"
            ><v-icon color="#ff846d">delete</v-icon></v-btn
          >
        </div>
        <v-layout row wrap class="px-4 ma-0">
          <v-flex xs12 sm3>
            <v-img style="width: 100%; height: auto" :src="item.img_url"></v-img>
          </v-flex>
          <v-flex xs12 sm9 class="pl-4">
            <div>
              <h2 style="color: black; word-wrap: break-word">
                {{ item.name }}
              </h2>
              <div class="mt-2">
                <span>เงื่อนไข : </span>
                <span>{{ item.condition_message }}</span>
              </div>

              <div class="mt-2">
                <div>
                  <span>วันที่เริ่มต้นกดรับ : </span>
                  <span>{{ item.start_receive_date | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                </div>
                <div>
                  <span>วันที่สิ้นสุดการกดรับ : </span>
                  <span>{{ item.end_receive_date | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                </div>
              </div>

              <div class="mt-2">
                <div>
                  <span>วันที่เริ่มต้นใช้ : </span>
                  <span>{{ item.start_using_date | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                </div>
                <div>
                  <span>วันที่สิ้นสุดการใช้ : </span>
                  <span>{{ item.end_using_date | DateFormat('DD/MM/YYYY HH:mm') }}</span>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-layout>
    <v-dialog v-model="showModelCreateCouponPool" max-width="800px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn icon @click="showModelCreateCouponPool = false"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <v-stepper v-model="modelStep" class="none-drop-shadow" vertical>
            <v-stepper-step :complete="modelStep > 1" step="1">ข้อมูลคูปอง</v-stepper-step>
            <v-stepper-content step="1">
              <v-card class="none-drop-shadow">
                <v-layout class="pa-0 ma-0" wrap row>
                  <v-flex xs12 class="form-control">
                    <div>อัปโหลดรูปคูปอง</div>
                    <UploadMultipleImageShow
                      v-if="showModelCreateCouponPool"
                      :max-length="1"
                      :value="noneFormatData.images"
                      @update="handleAddImage"
                    />
                  </v-flex>
                  <v-flex xs12 class="form-control">
                    <label>ชื่อคูปอง</label>
                    <input
                      v-model="activeData.name"
                      v-validate="'required'"
                      class="form-control"
                      type="text"
                      name="ชื่อคูปอง"
                    />
                    <div :class="{ 'has-error form-control': errors.has('ชื่อคูปอง') }">
                      <span v-if="errors.has('ชื่อคูปอง')" class="text-error">{{
                        errors.first('ชื่อคูปอง')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 class="form-control">
                    <label>รหัสคูปอง</label>
                    <input
                      v-model="activeData.pool_code"
                      v-validate="'required'"
                      class="form-control"
                      type="text"
                      name="รหัสคูปอง"
                    />
                    <div :class="{ 'has-error form-control': errors.has('รหัสคูปอง') }">
                      <span v-if="errors.has('รหัสคูปอง')" class="text-error">{{
                        errors.first('รหัสคูปอง')
                      }}</span>
                    </div>
                    <div class="text-gray" style="font-size: 12px">
                      รหัสนี้ต้องใช้กับฟังก์ชันเท่านั้น
                    </div>
                  </v-flex>
                  <v-flex xs12 class="form-control">
                    <label>ข้อความแจ้งเตือน</label>
                    <input v-model="activeData.noti_message" class="form-control" type="text" />
                  </v-flex>
                  <v-flex xs12 class="form-control">
                    <label>เงื่อนไขการใช้งาน</label>
                    <input
                      v-model="activeData.condition_message"
                      class="form-control"
                      type="text"
                    />
                  </v-flex>
                  <v-flex xs12 class="form-control">
                    <label>มูลค่าของรางวัล</label>
                    <input v-model="activeData.prize_value" class="form-control" type="number" />
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn outline color="grey" @click="showModelCreateCouponPool = false">ยกเลิก</v-btn>
              <v-btn color="primary" @click="handleNextStep"> ถัดไป </v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="modelStep > 2" step="2">เงื่อนไขการใช้คูปอง</v-stepper-step>

            <v-stepper-content step="2">
              <v-card class="none-drop-shadow">
                <v-layout class="pa-0 ma-0" wrap row>
                  <v-flex xs12 class="form-control">
                    <label>จำนวนคูปองที่แจก</label>
                    <input
                      v-model="activeData.max_coupon"
                      v-validate="'required'"
                      class="form-control"
                      type="number"
                      name="จำนวนคูปองที่แจก"
                    />
                    <div :class="{ 'has-error form-control': errors.has('จำนวนคูปองที่แจก') }">
                      <span v-if="errors.has('จำนวนคูปองที่แจก')" class="text-error">{{
                        errors.first('จำนวนคูปองที่แจก')
                      }}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 style="font-weight: bold" class="mt-3">
                    ระยะเวลาในการกดรับคูปอง
                  </v-flex>
                  <v-flex xs12 class="mt-2">
                    <label>ตั้งเวลาเปิด</label>
                    <v-layout row nowrap>
                      <v-flex xs6 class="mr-2">
                        <DatepickerCustomDialog
                          v-model="noneFormatData.start_receive_date"
                          v-validate="'required'"
                          class="form-control"
                          data-vv-name="วันที่เริ่มกดรับคูปอง"
                          data-vv-as="วันที่เริ่มกดรับคูปอง"
                        >
                          <input
                            placeholder="DD/MM/YYYY"
                            readonly
                            :value="getDateFormatted(noneFormatData.start_receive_date)"
                            type="text"
                          />
                        </DatepickerCustomDialog>
                        <div
                          v-show="errors.has('วันที่เริ่มกดรับคูปอง')"
                          style="margin-top: -20px"
                          class="text-error red--text"
                        >
                          {{ errors.first('วันที่เริ่มกดรับคูปอง') }}
                        </div>
                      </v-flex>
                      <v-flex xs6>
                        <CustomTimepicker
                          v-model="noneFormatData.start_receive_time"
                          v-validate="'required'"
                          class="form-control"
                          data-vv-name="เวลาเริ่มกดรับคูปอง"
                          data-vv-as="เวลาเริ่มกดรับคูปอง"
                        >
                          <input
                            placeholder="HH:mm"
                            readonly
                            :value="noneFormatData.start_receive_time"
                            type="text"
                          />
                        </CustomTimepicker>
                        <div
                          v-show="errors.has('เวลาเริ่มกดรับคูปอง')"
                          style="margin-top: -20px"
                          class="text-error red--text"
                        >
                          {{ errors.first('เวลาเริ่มกดรับคูปอง') }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="mt-2">
                    <label>ตั้งเวลาปิด</label>
                    <v-layout row nowrap>
                      <v-flex xs6 class="mr-2">
                        <DatepickerCustomDialog
                          v-model="noneFormatData.end_receive_date"
                          v-validate="'required'"
                          class="form-control"
                          data-vv-name="วันที่สิ้นสุดกดรับคูปอง"
                          data-vv-as="วันที่สิ้นสุดกดรับคูปอง"
                        >
                          <input
                            placeholder="DD/MM/YYYY"
                            readonly
                            :value="getDateFormatted(noneFormatData.end_receive_date)"
                            type="text"
                          />
                        </DatepickerCustomDialog>
                        <div
                          v-show="errors.has('วันที่สิ้นสุดกดรับคูปอง')"
                          style="margin-top: -20px"
                          class="text-error red--text"
                        >
                          {{ errors.first('วันที่สิ้นสุดกดรับคูปอง') }}
                        </div>
                      </v-flex>
                      <v-flex xs6>
                        <CustomTimepicker
                          v-model="noneFormatData.end_receive_time"
                          v-validate="'required'"
                          class="form-control"
                          data-vv-name="เวลาสิ้นสุดกดรับคูปอง"
                          data-vv-as="เวลาสิ้นสุดกดรับคูปอง"
                        >
                          <input
                            placeholder="HH:mm"
                            readonly
                            :value="noneFormatData.end_receive_time"
                            type="text"
                          />
                        </CustomTimepicker>
                        <div
                          v-show="errors.has('เวลาสิ้นสุดกดรับคูปอง')"
                          style="margin-top: -20px"
                          class="text-error red--text"
                        >
                          {{ errors.first('เวลาสิ้นสุดกดรับคูปอง') }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 style="font-weight: bold" class="mt-3">
                    ระยะเวลาในการใช้คูปอง
                  </v-flex>
                  <v-flex xs12 class="mt-2">
                    <label>ตั้งเวลาเปิด</label>
                    <v-layout row nowrap>
                      <v-flex xs6 class="mr-2">
                        <DatepickerCustomDialog
                          v-model="noneFormatData.start_using_date"
                          v-validate="'required'"
                          class="form-control"
                          data-vv-name="วันที่เริ่มใช้คูปอง"
                          data-vv-as="วันที่เริ่มใช้คูปอง"
                        >
                          <input
                            placeholder="DD/MM/YYYY"
                            readonly
                            :value="getDateFormatted(noneFormatData.start_using_date)"
                            type="text"
                          />
                        </DatepickerCustomDialog>
                        <div
                          v-show="errors.has('วันที่เริ่มใช้คูปอง')"
                          style="margin-top: -20px"
                          class="text-error red--text"
                        >
                          {{ errors.first('วันที่เริ่มใช้คูปอง') }}
                        </div>
                      </v-flex>
                      <v-flex xs6>
                        <CustomTimepicker
                          v-model="noneFormatData.start_using_time"
                          v-validate="'required'"
                          class="form-control"
                          data-vv-name="เวลาเริ่มใช้คูปอง"
                          data-vv-as="เวลาเริ่มใช้คูปอง"
                        >
                          <input
                            placeholder="HH:mm"
                            readonly
                            :value="noneFormatData.start_using_time"
                            type="text"
                          />
                        </CustomTimepicker>
                        <div
                          v-show="errors.has('เวลาเริ่มใช้คูปอง')"
                          style="margin-top: -20px"
                          class="text-error red--text"
                        >
                          {{ errors.first('เวลาเริ่มใช้คูปอง') }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="mt-2">
                    <label>ตั้งเวลาปิด</label>
                    <v-layout row nowrap>
                      <v-flex xs6 class="mr-2">
                        <DatepickerCustomDialog
                          v-model="noneFormatData.end_using_date"
                          v-validate="'required'"
                          class="form-control"
                          data-vv-name="วันที่สิ้นสุดใช้คูปอง"
                          data-vv-as="วันที่สิ้นสุดใช้คูปอง"
                        >
                          <input
                            placeholder="DD/MM/YYYY"
                            readonly
                            :value="getDateFormatted(noneFormatData.end_using_date)"
                            type="text"
                          />
                        </DatepickerCustomDialog>
                        <div
                          v-show="errors.has('วันที่สิ้นสุดใช้คูปอง')"
                          style="margin-top: -20px"
                          class="text-error red--text"
                        >
                          {{ errors.first('วันที่สิ้นสุดใช้คูปอง') }}
                        </div>
                      </v-flex>
                      <v-flex xs6>
                        <CustomTimepicker
                          v-model="noneFormatData.end_using_time"
                          v-validate="'required'"
                          class="form-control"
                          data-vv-name="เวลาสิ้นสุดใช้คูปอง"
                          data-vv-as="เวลาสิ้นสุดใช้คูปอง"
                        >
                          <input
                            placeholder="HH:mm"
                            readonly
                            :value="noneFormatData.end_using_time"
                            type="text"
                          />
                        </CustomTimepicker>
                        <div
                          v-show="errors.has('เวลาสิ้นสุดใช้คูปอง')"
                          style="margin-top: -20px"
                          class="text-error red--text"
                        >
                          {{ errors.first('เวลาสิ้นสุดใช้คูปอง') }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn outline color="grey" :loading="modelLoading" @click="modelStep = 1"
                >ย้อนกลับ</v-btn
              >
              <v-btn color="primary" :loading="modelLoading" @click="handleSaveData">
                บันทึก
              </v-btn>
            </v-stepper-content>
          </v-stepper>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import toaMegapaintApi from '@/api/toa-mega-paint.js'
import UploadMultipleImageShow from '@/components/elements/UploadMultipleImage/UploadMultipleImageShow'
import dayjs from 'dayjs'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'

const defaultNoneFormatData = {
  start_receive_date: '',
  start_receive_time: '',
  end_receive_date: '',
  end_receive_time: '',
  start_using_date: '',
  start_using_time: '',
  end_using_date: '',
  end_using_time: '',
  images: []
}
const defaultActiveData = {
  img_url: '',
  name: '',
  pool_code: '',
  noti_message: '',
  condition_message: '',
  prize_value: '',
  max_coupon: '',
  start_receive_date: null,
  end_receive_date: null,
  start_using_date: null,
  end_using_date: null
}

export default {
  components: { UploadMultipleImageShow, DatepickerCustomDialog, CustomTimepicker },
  data() {
    return {
      noneFormatData: {
        ...defaultNoneFormatData
      },
      activeData: {
        ...defaultActiveData
      },
      showModelCreateCouponPool: false,
      page: 1,
      limitPerPage: 10,
      loading: false,
      modelLoading: false,
      total: 0,
      ecouponPoolData: null,
      modelStep: 1
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    offset() {
      try {
        const offset = this.limitPerPage * this.page - this.limitPerPage
        return offset
      } catch (error) {
        return 0
      }
    },
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limitPerPage)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.setup()
  },
  methods: {
    getDateFormatted(val) {
      if (val) {
        return dayjs(val).format('DD/MM/YYYY')
      } else return ''
    },
    async setup() {
      try {
        this.loading = true
        const { total, data } = await this.fetchEcouponSetting()
        this.ecouponPoolData = data
        try {
          this.total = Number(total)
        } catch (error) {
          console.error(error)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async fetchEcouponSetting() {
      const params = {
        page_id: this.selectedBot.pageid,
        offset: this.offset,
        limit: this.limitPerPage
      }
      try {
        const response = await toaMegapaintApi.getCouponPoolSetting(params)
        return response.data
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          title: 'Load data fail'
        })
      }
    },
    showEditEcoupon(data) {
      this.activeData = data
      this.noneFormatData = {
        start_receive_date: dayjs(data.start_receive_date).format('YYYY-MM-DD'),
        start_receive_time: dayjs(data.start_receive_date).format('HH:mm'),
        end_receive_date: dayjs(data.end_receive_date).format('YYYY-MM-DD'),
        end_receive_time: dayjs(data.end_receive_date).format('HH:mm'),
        start_using_date: dayjs(data.start_using_date).format('YYYY-MM-DD'),
        start_using_time: dayjs(data.start_using_date).format('HH:mm'),
        end_using_date: dayjs(data.end_using_date).format('YYYY-MM-DD'),
        end_using_time: dayjs(data.end_using_date).format('HH:mm'),
        images: data.img_url ? [data.img_url] : []
      }
      this.showModelCreateCouponPool = true
      this.modelStep = 1
    },
    async deleteEcoupon(id) {
      if (id) {
        try {
          const confirm = await this.$swal.fire({
            title: this.$t('Do you want to delete this?'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })
          if (confirm.value) {
            await toaMegapaintApi.deleteCouponPoolSetting(id, this.selectedBot.pageid)
            this.setup()
          }
        } catch (error) {
          console.error(error)
          this.$swal.fire({
            type: 'error',
            title: 'ลบข้อมูลไม่สำเร็จ'
          })
        }
      } else {
        this.$swal.fire({
          type: 'error',
          title: 'ไม่พบ id'
        })
      }
    },
    handleAddImage(images) {
      if (images && images[0]) {
        this.activeData.img_url = images[0]
      }
    },
    async handleSaveData() {
      const validateData = await this.$validator.validateAll()
      if (validateData) {
        this.activeData.page_id = this.selectedBot.pageid
        this.activeData.start_receive_date = dayjs(
          `${this.noneFormatData.start_receive_date} ${this.noneFormatData.start_receive_time}`
        ).format('YYYY-MM-DD HH:mm')
        this.activeData.end_receive_date = dayjs(
          `${this.noneFormatData.end_receive_date} ${this.noneFormatData.end_receive_time}`
        ).format('YYYY-MM-DD HH:mm')
        this.activeData.start_using_date = dayjs(
          `${this.noneFormatData.start_using_date} ${this.noneFormatData.start_using_time}`
        ).format('YYYY-MM-DD HH:mm')
        this.activeData.end_using_date = dayjs(
          `${this.noneFormatData.end_using_date} ${this.noneFormatData.end_using_time}`
        ).format('YYYY-MM-DD HH:mm')

        if (this.activeData.id) {
          this.fetchUpdateData(this.activeData)
        } else {
          this.fetchCreateData(this.activeData)
        }
      }
    },
    async fetchCreateData(body) {
      try {
        this.modelLoading = true
        await toaMegapaintApi.postCouponPoolSetting(body)
        this.noneFormatData = {
          ...defaultNoneFormatData
        }
        this.activeData = {
          ...defaultActiveData
        }
        this.showModelCreateCouponPool = false
        this.setup()
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          title: 'บันทึกข้อมูลไม่สำเร็จ'
        })
      } finally {
        this.modelLoading = false
      }
    },
    async fetchUpdateData(body) {
      try {
        this.modelLoading = true
        await toaMegapaintApi.putCouponPoolSetting(body.id, body)
        this.noneFormatData = {
          ...defaultNoneFormatData
        }
        this.activeData = {
          ...defaultActiveData
        }
        this.showModelCreateCouponPool = false
        this.setup()
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          title: 'อัพเดทข้อมูลไม่สำเร็จ'
        })
      } finally {
        this.modelLoading = false
      }
    },
    async handleNextStep() {
      const validateName = await this.$validator.validate('ชื่อคูปอง')
      const validatePoolCOde = await this.$validator.validate('รหัสคูปอง')
      if (validateName && validatePoolCOde) {
        this.modelStep = 2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.none-drop-shadow {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ToaMegaPaintCreateEcoupon.vue